export const URLs = {
    Fornecedores: {
        urlVisualizacao: "fornecedores",
        urlCriacao: "fornecedores/cadastrar",
        permissao: "Fornecedores",
    },
    Colaboradores: {
        urlVisualizacao: "colaboradores",
        urlCriacao: "colaboradores/cadastrar",
        permissao: "Colaboradores",
    },
    GruposFornecedores: {
        urlVisualizacao: "grupo-fornecedores",
        urlCriacao: "grupo-fornecedores/cadastrar",
        permissao: "GruposFornecedores",
    },
    Ancoras: {
        urlVisualizacao: "ancoras",
        urlCriacao: "ancoras/cadastrar",
        permissao: "Ancoras",
    },
    CartoesPontos: {
        urlVisualizacao: "cartoes-ponto",
        urlCriacao: "cartoes-ponto/cadastrar",
        permissao: "CartoesPonto",
    },
    Plataformas: {
        urlVisualizacao: "plataformas",
        urlCriacao: "plataformas/cadastrar",
        permissao: "Plataformas",
    },
    Relatorio001Producao: {
        urlVisualizacao: "relatorio/producao",
        urlCriacao: "relatorio/producao",
        permissao: "Relatorio001Producao",
    },
    Relatorio005ProducaoDiaria: {
        urlVisualizacao: "relatorio/producao/diaria",
        urlCriacao: "relatorio/producao/diaria",
        permissao: "Relatorio005ProducaoDiaria",
    },
    Relatorio002Metas: {
        urlVisualizacao: "relatorio/metas",
        urlCriacao: "relatorio/metas",
        permissao: "Relatorio002Metas",
    },
    Relatorio003Diario: {
        urlVisualizacao: "relatorios/diario",
        urlCriacao: "relatorios/diario",
        permissao: "Relatorio003Diario",
    },
    Relatorio004Mensal: {
        urlVisualizacao: "relatorios/mensal",
        urlCriacao: "relatorios/mensal",
        permissao: "Relatorio004Mensal",
    },
    Relatorio006ContasAPagar: {
        urlVisualizacao: "relatorio/contasAPagar",
        urlCriacao: "relatorios/contasAPagar",
        permissao: "Relatorio006ContasAPagar",
    },
    Relatorio007CartaoPonto: {
        urlVisualizacao: "relatorio/timecard",
        urlCriacao: "relatorios/timecard",
        permissao: "Relatorio007CartaoPonto",
    },
    Relatorio008Comparativo: {
        urlVisualizacao: "relatorio/comparativo",
        urlCriacao: "relatorios/comparativo",
        permissao: "Relatorio008Comparativo",
    },
    Relatorio009AcumuladoRede: {
        urlVisualizacao: "relatorio/acumuladoRede",
        urlCriacao: "relatorios/acumuladoRede",
        permissao: "Relatorio009AcumuladoRede",
    },
    Relatorio010AnalistasAncorasAntecipacoes: {
        urlVisualizacao: "relatorio/ancoraAntecipacoes",
        urlCriacao: "relatorio/ancoraAntecipacoes",
        permissao: "Relatorio010AnalistasAncorasAntecipacoes",
    },
    RelatoriosDinamicos: {
        urlVisualizacao: "relatorio/dinamicos",
        urlCriacao: "relatorio/dinamicos",
        permissao: "RelatoriosDinamicos",
    },
    "FechamentoMensal": {
        urlVisualizacao: "relatorio/fechamentoMensal",
        urlCriacao: "relatorio/fechamentoMensal",
        permissao: "AncoraFechamentoMeses",
    }
};

  export const urlsControle = [
    '/app/home',
    '/app/relatorios',
    '/app/cadastros',
    '#',
    '#',
    '#'
  ]